/* global Blockly */
import React from 'react';
import {paragraphIcon} from "./index";

// everything in init should be ES5
function defineBlock(context) {
    return {
        init: function () {
            this.appendDummyInput("TEXT")
                .appendField("get")
                .appendField(new Blockly.FieldImage(paragraphIcon, 30, 30, "paragraph icon", null), 'paragraphIcon')
                .appendField(new Blockly.FieldWidgetsDropdown(context, "paragraph", undefined, '- select -'), "ID")
                .appendField("text");
            this.setPreviousStatement(false);
            this.setNextStatement(false);
            this.setOutput(true, 'String'); // add appropriate checks
            this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND); // add appropriate checks
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Get the display text of the provided paragraph widget.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#widget-values');
        },
        onchange: function(){
            if (this.getField('paragraphIcon') && this.getField('paragraphIcon').imageElement_)
                this.getField('paragraphIcon').setTooltip('Paragraph');
        }
    }
}

function defineGenerators() {
    // generators dictionary in ES5
    return {
        'JavaScript': function (block) {
            let id = block.getFieldValue("ID");
            return ["Snap.widgets.paragraph.getDisplayText('" + id + "')", Blockly.JavaScript.ORDER_NONE];
        }
    }
}

const GetParagraphText = function (props) {
    let name = "snap_get_paragraph_text";
    GetParagraphText.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);

    let generators = defineGenerators(props.context);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (props.widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {props.widget && (props.widget.id !== undefined)
                ? <field name="ID">{props.widget.id}</field>
                : null
            }
        </block>
    );
}

export default GetParagraphText;